import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import {
  OPEN_BROKEN_ASSETS_DRAWER_EVENT,
  OPEN_AUTO_INSIGHTS_DRAWER_EVENT,
} from '@src/pages/AutoInsights/constants';
import { HandlerOptions } from './types';

/**
 * Handles fetch_broken_assets_csv tool - opens Broken Assets drawer via custom event
 * First opens the main AutoInsights drawer, then triggers the specific drawer
 */
export const handleBrokenAssets = (options: HandlerOptions): void => {
  try {
    // First, open the main AutoInsights drawer (required for component to be mounted)
    const mainDrawerEvent = new CustomEvent(OPEN_AUTO_INSIGHTS_DRAWER_EVENT, {
      detail: { visible: true },
    });
    document.dispatchEvent(mainDrawerEvent);

    // Then, after a short delay to ensure component is mounted, open the specific drawer
    setTimeout(() => {
      const event = new CustomEvent(OPEN_BROKEN_ASSETS_DRAWER_EVENT);
      window.dispatchEvent(event);
    }, 100);

    apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'broken_assets' });
    logger.log('Triggered Broken Assets drawer via custom event');
  } catch (error) {
    logger.error('Error handling broken assets:', error);
  }
};
